import * as React from "react";
import { useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { api } from "../../../../../utils/axios";

interface RosterActivateBillingProps {
    clientId: string;
}

const RosterActivateBilling: React.FC<RosterActivateBillingProps> = ({ clientId }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<string | null>(null);

    const handleActivate = async () => {
        setLoading(true);
        setResult(null);
        try {
            const res = await api.post("/admin/rosters/activate-billing", {
                client_id: clientId,
            });
            setResult(`✅ ${res.data.message}`);
        } catch (err) {
            console.error("Activation failed", err);
            setResult("❌ Activation failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h5" gutterBottom>
                Activate Billing Records
            </Typography>

            <Button
                variant="contained"
                color="primary"
                onClick={handleActivate}
                disabled={loading}
                sx={{ mt: 2 }}
            >
                Activate Now
            </Button>

            {loading && (
                <Box sx={{ mt: 2 }}>
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                        Activating records...
                    </Typography>
                </Box>
            )}

            {result && (
                <Typography sx={{ mt: 2 }} color="primary">
                    {result}
                </Typography>
            )}
        </Box>
    );
};

export default RosterActivateBilling;
